var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"plot",staticClass:"legend scrollbox bg"})
}
var staticRenderFns = []

export { render, staticRenderFns }